import { icons } from '@lifebit-ai/lds'
import React from 'react'

import * as styles from 'modules/resultsV2/PreviousApprovalDetails.styles'
import type { Result } from 'services/results/types'
import { RequestCard } from 'ui/card/card.styles'

import usePreviousAppealApprovalDetails from './hooks/usePreviousAppealApprovalDetails'

interface PreviousAppealRejectedRequestDetailsProps {
  result: Result
}

export const PreviousAppealRejectedRequestDetails = ({
  result
}: PreviousAppealRejectedRequestDetailsProps): JSX.Element => {
  const {
    cardTitle,
    firstOriginalRequestIdentifierUrl,
    originallyRejectedBy,
    originalRejectionDate,
    reasonForRejection
  } = usePreviousAppealApprovalDetails({ result })

  return (
    <RequestCard>
      <styles.CardContent>
        <styles.CardSectionTitle>{cardTitle}</styles.CardSectionTitle>
        <styles.Details>
          <styles.Label>First original request link</styles.Label>
          <styles.Link href={firstOriginalRequestIdentifierUrl} target="_blank" rel="noopener noreferrer">
            <span>Original request</span>
            <icons.OpenSmall />
          </styles.Link>
          <styles.Label>Originally rejected by</styles.Label>
          <styles.Value>{originallyRejectedBy}</styles.Value>
          <styles.Label>Original rejection date</styles.Label>
          <styles.Value>{originalRejectionDate}</styles.Value>
          <styles.Label>Reason for rejection</styles.Label>
          <styles.Value>{reasonForRejection}</styles.Value>
        </styles.Details>
      </styles.CardContent>
    </RequestCard>
  )
}
